import Enums from "../../../../utils/Enums";

let doc = [
  {
    desc: "PRUWorks HR User Guide - PRUTreasures Flexi II",
    fileNameOriginal: "PRUWorks HR User Guide - PRUTreasures Flexi II.pdf",
    fileName: "PRUWorks HR User Guide - PRUTreasures Flexi II.pdf",
    type: [Enums.P_CODE.PRU_AGENCY, Enums.P_CODE.SCB_ASSISTED, Enums.P_CODE.UOB_ASSISTED, Enums.P_CODE.PFA],
    code: { PTF: [Enums.PLANS_CODE.HDF], GCP: [Enums.PLANS_CODE.HDF], PF3: [Enums.PLANS_CODE.HDF] }
  },
  {
    desc: "PRUWorks HR User Guide - Group Customised Plan",
    fileNameOriginal: "PRUWorks HR User Guide - Group Customised Plan.pdf",
    fileName: "PRUWorks HR User Guide - Group Customised Plan.pdf",
    type: [Enums.P_CODE.PRU_AGENCY, Enums.P_CODE.SCB_ASSISTED, Enums.P_CODE.UOB_ASSISTED, Enums.P_CODE.PFA],
    code: { PTF: [Enums.PLANS_CODE.HDF], GCP: [Enums.PLANS_CODE.HDF], PF3: [Enums.PLANS_CODE.HDF] }
  }
];

export default doc;
